import React from 'react';
import { motion } from 'framer-motion';
import { portfolioData } from '../data/mock';

const AboutSection = () => {
  const { about } = portfolioData;
  
  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 md:px-12 lg:px-24">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-2"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl" style={{ fontFamily: 'Cinzel, serif', color: 'rgba(235, 240, 250, 0.95)', fontWeight: 400 }}>
            {about.heading}
          </h2>
        </motion.div>
        
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mb-8"
          style={{ fontFamily: 'DM Mono, monospace', color: 'rgba(150, 170, 200, 0.7)', fontSize: '0.85rem' }}
        >
          {about.subtitle}
        </motion.p>
        
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.25, 0.46, 0.45, 0.94] }}
          whileHover={{ scale: 1.01 }}
          className="glass-panel p-6 sm:p-8 md:p-12"
        >
          <div className="grid md:grid-cols-3 gap-8 md:gap-10">
            <div className="md:col-span-2 space-y-5 sm:space-y-6">
              {about.poeticBio.split('\n\n').map((paragraph, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.7, delay: 0.2 + index * 0.15 }}
                  className="relative"
                >
                  <motion.div
                    initial={{ width: 0 }}
                    whileInView={{ width: '100%' }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.1 + index * 0.15 }}
                    className="absolute top-0 left-0 h-px"
                    style={{ background: 'rgba(180, 195, 220, 0.25)' }}
                  />
                  <p className="text-sm sm:text-base md:text-lg leading-relaxed pt-4" style={{ fontFamily: 'EB Garamond, serif', color: 'rgba(220, 230, 245, 0.9)', lineHeight: '1.85' }}>
                    {paragraph}
                  </p>
                </motion.div>
              ))}
            </div>
            
            <div className="flex flex-col items-center justify-center">
              <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.5 }}
                className="relative mb-6"
              >
                <svg width="200" height="120" viewBox="0 0 200 120" fill="none">
                  <ellipse cx="45" cy="90" rx="25" ry="25" stroke="rgba(180,195,220,0.25)" strokeWidth="2" fill="rgba(15,20,28,0.5)"/>
                  <ellipse cx="155" cy="90" rx="25" ry="25" stroke="rgba(180,195,220,0.25)" strokeWidth="2" fill="rgba(15,20,28,0.5)"/>
                  <path d="M45 90 L70 50 L130 45 L155 90" stroke="rgba(180,195,220,0.25)" strokeWidth="2" fill="none"/>
                  <path d="M70 50 L85 30 L95 32 L90 50" stroke="rgba(180,195,220,0.25)" strokeWidth="2" fill="rgba(15,20,28,0.5)"/>
                  <path d="M90 50 L130 45 L135 55 L95 58 Z" fill="rgba(15,20,28,0.5)" stroke="rgba(180,195,220,0.2)" strokeWidth="1"/>
                  <ellipse cx="45" cy="90" rx="12" ry="12" fill="rgba(10,15,22,0.8)"/>
                  <ellipse cx="155" cy="90" rx="12" ry="12" fill="rgba(10,15,22,0.8)"/>
                </svg>
                <div className="absolute inset-0 overflow-hidden">
                  {[...Array(5)].map((_, i) => (
                    <motion.div
                      key={i}
                      className="absolute h-px"
                      style={{ width: `${Math.random() * 20 + 10}px`, top: `${70 + Math.random() * 30}%`, right: '-20px', background: 'rgba(180, 195, 220, 0.2)' }}
                      animate={{ x: [-200, 0] }}
                      transition={{ duration: 1 + Math.random(), repeat: Infinity, delay: i * 0.3, ease: 'linear' }}
                    />
                  ))}
                </div>
              </motion.div>
              
              <motion.p
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.7 }}
                className="text-center"
                style={{ fontFamily: 'EB Garamond, serif', fontStyle: 'italic', color: 'rgba(180, 195, 220, 0.8)', fontSize: '0.95rem' }}
              >
                "{about.ktmQuote}"
              </motion.p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;
